<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">
        MODIFICA POSIZIONE STORE
    </div>
    <h6>
        {{name_store}}
        <br>
        ( Latitudine: {{center.lat}} ; Longitudine: {{center.lng}} )
    </h6>
</div>

<!-- Modal body -->
<div class="modal-body">
    <div class="row">
        <div class="col-12 d-flex">
            <div class="infomarker-box d-flex">
                <div class="infomarker-img-box">
                    <img alt="" title="marker store" src="{{markerImage}}" width="auto" height="40" />
                </div>
                <div>
                    {{actualAddress}}
                    <br>
                    ( Latitudine: {{actualCenter.lat}} ; Longitudine: {{actualCenter.lng}} )
                </div>
            </div>
        </div>
    </div>
    <div class="row pt-4 px-4">
        <div id="map">
        </div>
    </div>


    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="button" class="btn btn-fw text me-3" [disabled]="isButtonSaveDisabled"
                (click)="clickButtonSave()">Seleziona</button>
            <button type="button" class="btn btn-outline-warning btn-outline-fw text"
                (click)="clickButtonCancel()">Annulla</button>
        </div>
    </div>
</div>